import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Global } from '../global';

export interface CertificadoRequest {
  documentId: string;
  email?: string;
  year: string;
}

export interface CertificadoResponse {
  message: string;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class CertificadosService {

  private API_URL: string;

  constructor(
    private readonly httpClient: HttpClient
  ) {
    this.API_URL = Global.url + '/certificates';
  }

  getCertificado(token: string, data: CertificadoRequest): Observable<CertificadoResponse> {
    return this.httpClient.post<CertificadoResponse>(`${this.API_URL}/certificado-ingresos-retenciones`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
      .pipe(
        tap(response => {
          console.log('Certificado obtenido exitosamente');
        }),
        catchError(error => {
          console.error('Error al obtener certificado:', error);
          throw error;
        })
      );
  }

  getCertificadoTributarioCDT(token: string, data: CertificadoRequest): Observable<CertificadoResponse> {
    return this.httpClient.post<CertificadoResponse>(`${this.API_URL}/certificado-tributario`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }

  getCertificadoCuentasAhorro(token: string, data: CertificadoRequest): Observable<CertificadoResponse> {
    return this.httpClient.post<CertificadoResponse>(`${this.API_URL}/certificado-cuentas-ahorro`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }

  getCertificadoCredito(token: string, data: CertificadoRequest): Observable<CertificadoResponse> {
    return this.httpClient.post<CertificadoResponse>(`${this.API_URL}/certificado-credito`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }

  getCertificadoCostosTotales(token: string, data: CertificadoRequest): Observable<CertificadoResponse> {
    return this.httpClient.post<CertificadoResponse>(`${this.API_URL}/certificado-costos`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  }


  downloadCertificadoAsFile(token: string, data: CertificadoRequest): Observable<Blob> {
    return this.httpClient.post(`${this.API_URL}/certificado-ingresos-retenciones`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    })
      .pipe(
        tap(() => {
          console.log('Archivo de certificado descargado exitosamente');
        }),
        catchError(error => {
          console.error('Error al descargar archivo de certificado:', error);
          throw error;
        })
      );
  }
}
